import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";

/** Nothing fancy; this is a simple bordered block */
const Well = props => {
  const { className, children, ...other } = props;

  return (
    <div className={clsx("em-c-well", className)} {...other}>
      {children}
    </div>
  );
};

Well.propTypes = {
  /** Additional css classNames to append to the outer element */
  className: PropTypes.string,
  /** React component children */
  children: PropTypes.node
};

Well.defaultProps = {
  className: "",
  children: null
};

export default Well;
